export default __webpack_public_path__ + "static/media/logo.c1e7e187.webp";